import { select as d3_select, selectAll as d3_selectAll } from 'd3-selection'
import MultiDataDataController from './MultiDataDataController'
import { isDarkMode } from '../utils/configUtils'

function RootBehavior($chartContainer, viz, config) {
  let pages = viz.data?.isMulti ? viz.data.data : [null]
  let chartsData =
    viz.data?.isMulti && config.MultiDataPickerBehavior.multiDataMode === 'smallmultiples'
      ? pages
      : [pages.find(p => String(p?.id) === String(config.currentPage)) || pages[0]]
  let columns = +config.MultiDataPickerBehavior.smallMultiplesColumns || 2
  let chartContainer = d3_select($chartContainer)
  if (chartsData.length > 1) {
    chartContainer
      .style('display', 'grid')
      .style('grid-template-columns', [...Array(columns).keys()].map(() => '1fr').join(' '))
    d3_select(chartContainer.node().closest('.chart-container'))
      .style('overflow', 'auto')
      .style('position', 'relative')
  } else {
    chartContainer
      .style('display', 'flex')
      .style('grid-template-columns', null)
      .style('flex-direction', 'column')
  }

  let chartContainers = chartContainer
    .selectAll('.chart-wrapper')
    .data(chartsData, d =>
      config.MultiDataPickerBehavior.multiDataMode === 'smallmultiples' ? d?.id : null
    )
  chartContainers.exit().remove()
  let chartContainersEnter = chartContainers
    .enter()
    .append('div')
    .attr('class', 'chart-wrapper')
    .style('width', '100%')
    .style('flex', '1 1 auto')
    .style('display', 'flex')
    .style('flex-direction', 'column')

  chartContainersEnter
    .append('div')
    .attr('class', 'page-title')
    .style('font-weight', 'bold')
    .style('font-size', '14px')
    .text(d => d?.id)

  chartContainersEnter
    .append('svg')
    .attr('class', 'chart')
    .style('width', '100%')
    .style('flex', '1 1 auto')

  chartContainers = chartContainers.merge(chartContainersEnter)

  chartContainers
    .select('.page-title')
    .style('color', () => {
      return isDarkMode(config, viz.accessibilityOptions) ? '#fff' : '#222'
    })
    .text(d => d?.id)
    .style('display', () =>
      config.MultiDataPickerBehavior.multiDataMode === 'smallmultiples' ? 'inherit' : 'none'
    )

  let altDesc = chartContainers
    .select('.chart')
    .selectAll('desc')
    .data(config.AccessibilityBehavior.altDesc ? [null] : [])
  const altDescEnter = altDesc.enter().append('desc')
  altDesc.exit().remove()
  altDesc = altDesc.merge(altDescEnter)
  altDesc.text(config.AccessibilityBehavior.altDesc).lower()

  let altTitle = chartContainers.select('.chart').selectAll('title').data([null])
  const altTitleEnter = altTitle.enter().append('title')
  altTitle = altTitle.merge(altTitleEnter)
  altTitle.text(config.AccessibilityBehavior.altTitle || config.title).lower()

  chartContainersEnter.each(function (data) {
    let chart = new viz.__proto__.constructor.chartClass(this.querySelector('.chart'), viz.config)
    chart._parent = viz
    chart.helperListeners.afterItemsHelper = viz.afterItemsHelper.bind(viz)
    this._chart = chart
    chart.addEventListener('select', d => {
      // hay que reseleccionar, para que el "charts[0]" tenga accesso a los otros
      let ccs = chartContainer.selectAll('.chart-wrapper')
      ccs.nodes().forEach(cc => chart !== cc._chart && cc._chart.selectById(d[0]?.id || null))
    })
  })
  let _charts = chartContainers.nodes().map(el => el._chart)
  Object.defineProperty(viz, 'chart', {
    get() {
      return new Proxy(_charts[0], {
        get(target, prop, receiver) {
          // if(prop==='allData') return _charts[0].allData
          if (Array.isArray(target[prop])) {
            // si no existe c[prop] no lo metemos... (?)
            return _charts
              .map(c => c[prop])
              .filter(d => d)
              .flat()
          } else if (target[prop]?.constructor.name === 'Selection') {
            if (_charts.length === 1) return _charts[0][prop]
            let iter = _charts.reduce((arr, c) => {
              if (c[prop]) arr = arr.concat(c[prop].nodes())
              return arr
            }, [])
            return d3_selectAll(iter.flat())
          }
          return Reflect.get(...arguments)
        },
        set(target, prop, value, receiver) {
          _charts.forEach(c => {
            c[prop] = value
          })
          return true
        },
      })
    },

    set(value) {
      console.log('CANNOT SET CHART on VIZ!!!!')
    },
    configurable: true,
  })

  if (!viz.$annotationsContainer) {
    // viz.$chartRoot = chartContainers.select('svg').nodes()[0]
    viz.$annotationsContainer = d3_select($chartContainer.parentElement)
      .append('svg')
      .attr('class', 'annotations-container')
      .style('position', 'absolute')
      .style('pointer-events', 'none')
      .node()
  }
  // d3_select(viz.$annotationsContainer.parentElement).raise().style('max-width',$chartContainer.scrollWidth+'px').style('max-height',$chartContainer.scrollHeight+'px')
  // d3_select(viz.$annotationsContainer).style('width',0).style('height',0)
  viz.setChartData = function (sourceData) {
    chartContainers.each(function (page) {
      let hiddenItems = viz.hiddenItems || []
      let data = MultiDataDataController(sourceData, page?.id)

      let visibleData = viz.__proto__.constructor.dataControllerClass(data, viz.config, hiddenItems)
      let allData = viz.__proto__.constructor.dataControllerClass(data, viz.config)
      this._chart.allData = allData
      // this._chart.config = viz.config
      // this._chart.data = visibleData
      this._chart.configAndData = { config: viz.config, data: visibleData }
    })
  }

  viz.setChartConfigAndData = function (config, sourceData) {
    chartContainers.each(function (page) {
      let hiddenItems = viz.hiddenItems || []
      let data = MultiDataDataController(sourceData, page?.id)

      let visibleData = viz.__proto__.constructor.dataControllerClass(data, viz.config, hiddenItems)
      let allData = viz.__proto__.constructor.dataControllerClass(data, viz.config)
      this._chart.allData = allData
      // this._chart.config = viz.config
      // this._chart.data = visibleData
      this._chart.configAndData = { config: config, data: visibleData }
    })
  }
  viz.setChartConfig = function (config) {
    chartContainers.each(function (d) {
      this._chart.config = config
    })
  }
}

RootBehavior.defaultConfig = {
  // smallMultiples: {
  //   type: Boolean,
  //   default: true,
  //   exposed: true,
  // },
}
RootBehavior.configName = 'RootBehavior'

export default RootBehavior
